<template>
    <div :class="['search-locator-filters', { 'loading': isStatus('loading'), 'is-empty': items.length === 0 }]">

            <div class="form-group">
                <h2 class="text-light">{{ labels.our_distributors }}</h2>
                <div class="input-group">
                    <input type="text" class="form-control" name="search" id="search" :placeholder="labels.search" v-model="search" v-on:keyup="filter()">
                    <span class="input-group-text">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#282828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M20.9984 21L16.6484 16.65" stroke="#282828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
                <br>
                <label for="country" class="form-label fw-bold" style="font-size: 1.25rem;">{{ labels.country }}</label>
                <select class="form-select" name="country" id="country" v-model="country" v-on:change="filter()">
                    <option value="" selected>{{ labels.choose }}</option>
                    <option v-for="count in countries" v-bind:value="count">
                        {{ count }}
                    </option>
                </select>
                <br>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <input type="checkbox" class="form-check-input" id="maintenance_center" name="maintenance_center" v-model="maintenance_center" v-on:change="filter()">
                        <label  class="form-check-label" for="maintenance_center" style="font-size: 0.68rem">{{ labels.maintenance_center }}</label>
                    </div>
                    <div class="col-12 col-md-6">
                        <input type="checkbox" class="form-check-input" id="dealer_sales_representative" name="dealer_sales_representative" v-model="dealer_sales_representative" v-on:change="filter()">
                        <label  class="form-check-label" for="dealer_sales_representative" style="font-size: 0.68rem">{{ labels.dealer_sales_representative }}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <input type="checkbox" class="form-check-input" id="demo_helicopter" name="demo_helicopter" v-model="demo_helicopter" v-on:change="filter()">
                        <label  class="form-check-label" for="demo_helicopter" style="font-size: 0.68rem">{{ labels.demo_helicopter }}</label>
                    </div>
                    <div class="col-12 col-md-6">
                        <input type="checkbox" class="form-check-input" id="helicopter_school" name="helicopter_school" v-model="helicopter_school" v-on:change="filter()">
                        <label  class="form-check-label" for="helicopter_school" style="font-size: 0.68rem">{{ labels.helicopter_school }}</label>
                    </div>
                </div>

                <!-- <button type="button" v-on:click="resetFilters()">Reset</button> -->
            </div>

    </div>
</template>

<script>
import { scrollTo } from '../helpers/utils';
import { withStatus } from '@cherrypulp/vue-utils';

export default {
    mixins: [ withStatus() ],

    props: {
        items: {
            default() {
                return [];
            },
            type: Array,
        },
        labels: {
            default() {
                return [];
            },
        },
    },

    data() {
        return {
            search: '',
            country: '',
            maintenance_center: false,
            dealer_sales_representative: false,
            demo_helicopter: false,
            helicopter_school: false,
            allItems: JSON.parse(JSON.stringify(this.items)),
            filtereds: JSON.parse(JSON.stringify(this.items)),
            countries: ['BE', 'FR', 'NL'],
        };
    },

    methods: {
        filter() {
            console.log(this.dealer_sales_representative);
            this.filtereds = JSON.parse(JSON.stringify(this.allItems));
            for (let i of this.filtereds.keys()) {
                //delete by search
                if(!this.filtereds[i].title.toLowerCase().includes(this.search.toLowerCase())){
                    delete this.filtereds[i];
                }
                //delete by country
                if(this.country != '' && this.filtereds[i].country != this.country){
                    delete this.filtereds[i];
                }

                //delete by checkboxes
                if(this.maintenance_center && this.filtereds[i].maintenance_center == "0"){
                    delete this.filtereds[i];
                }
                if(this.dealer_sales_representative && this.filtereds[i].dealer_sales_representative == "0"){
                    delete this.filtereds[i];
                }
                if(this.demo_helicopter && this.filtereds[i].demo_helicopter == "0"){
                    delete this.filtereds[i];
                }
                if(this.helicopter_school && this.filtereds[i].helicopter_school == "0"){
                    delete this.filtereds[i];
                }
            }
            this.$emit('filter', this.filtereds);
        },


        resetFilters(){
            this.filtereds = JSON.parse(JSON.stringify(this.allItems));
            this.$emit('filter', this.allItems);
        }
    },

    created() {
        //this.allItems = this.items;
        //console.log(this.allItems);
    },

    mounted() {
        this.setStatus('ready', true);
        this.countries = [];
        for(var item in this.allItems) {
            if(!this.countries.includes(this.allItems[item].country)){
                this.countries.push(this.allItems[item].country);
            }
        }
    },
};
</script>

<style lang="scss">
 .input-group-text{
     background-color: white !important;
 }
 .form-control{
    border-right:1px solid #ffffff !important;
 }
</style>
